export const PartnerOverviewLoader = () => {
  return (
    <>
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="flex flex-col rounded-md bg-white p-4">
          <p className="animate-glow h-6" />
          <div className="animate-glow my-5 h-24" />
          <p className="animate-glow h-6" />
        </div>
      ))}
    </>
  );
};
